const parseCookieValue = (cookie) => {
    const decodedCookie = decodeURIComponent(cookie);
    const id = decodedCookie.split(',')[0];
    return id;
};

export { parseCookieValue as default };
//# sourceMappingURL=parse.js.map
